import { Box, BoxProps, Typography } from '@mui/material';

import { RefreshCcw03Icon } from '@/components/icons/RefreshCcw03Icon';
import { useAssetProviderDisplayName } from '@/modules/assetProviderIntegrations/shared/hooks/useEnabledAssetsIntegrations';
import { COLORS } from '@/styles/tokens/colors';
import { FONT_WEIGHTS } from '@/styles/tokens/fonts';

export interface IntegrationContextBannerProps extends BoxProps {
  variant: 'linked' | 'linked-with-manual';
}

export function IntegrationContextBanner({
  variant,
  ...boxProps
}: IntegrationContextBannerProps) {
  const integrationProviderName = useAssetProviderDisplayName({
    isInline: true,
  });
  return (
    <Box textAlign="center" {...boxProps}>
      <RefreshCcw03Icon color={COLORS.GRAY[200]} size={48} />
      <Typography variant="title-xl" gutterBottom={variant === 'linked'}>
        Linked to {integrationProviderName}
      </Typography>
      {variant === 'linked-with-manual' && (
        <Typography
          fontWeight={FONT_WEIGHTS.medium}
          variant="title-l"
          gutterBottom
        >
          with additional manual tracking
        </Typography>
      )}
      <Typography variant="body-s" sx={{ maxWidth: '80%', mx: 'auto' }}>
        {variant === 'linked'
          ? 'Valuation changes will be captured automatically moving forward'
          : 'Valuation changes will be captured automatically and tallied with manually entered assets'}
      </Typography>
    </Box>
  );
}
